<template>
  <div>
    <v-dialog
      v-if="systemDialog"
      v-model="showDialog"
      :persistent="systemDialog.persistentDialog"
      max-width="400"
    >
      <v-card>
        <v-card-title
          v-if="systemDialog.title"
          v-html="systemDialog.title"
          style="word-break: break-word"
        ></v-card-title>

        <template v-if="systemDialog.message">
          <v-divider></v-divider>

          <v-card-text
            v-html="systemDialog.message"
            class="my-6 pb-0 black--text"
            style="font-size: initial"
          ></v-card-text>

          <v-divider v-if="systemDialog.title"></v-divider>
        </template>

        <!-- <v-checkbox
          v-if="localStorageKey4DontShowAgain"
          v-model="checkboxDontShowAgain"
          :label="`Don't show again`"
          class="pl-5"
        ></v-checkbox>-->

        <v-card-actions>
          <v-spacer></v-spacer>
          <div
            v-if="
              systemDialog.actions &&
              systemDialog.actions.actionType === 'YesOrNo'
            "
          >
            <v-btn color="primary" text @click="noClicked">No</v-btn>

            <v-btn color="primary" text @click="yesClicked">{{
              systemDialog.actions.yes.label || "Yes"
            }}</v-btn>
          </div>

          <v-btn v-else color="primary" text @click="okClicked">{{
            systemDialog.buttonLabel || "OK"
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
// import localStorageHelper from "@/helpers/localStorageHelper";

export default {
  name: "SystemDialog",
  data: () => ({
    showDialog: false,
    checkboxDontShowAgain: false,
  }),
  computed: {
    ...mapState(["systemDialog"]),
    // ...mapState(["dialog", "localStorageKey4DontShowAgain"])
  },
  watch: {
    systemDialog(newValue, oldValue) {
      this.checkboxDontShowAgain = false;

      if (newValue) {
        this.showDialog = true;
      }
    },
  },
  methods: {
    // ...mapMutations(["updateSystemDialog"]),
    // ...mapMutations(["updateLocalStorageKey4DontShowAgain"]),
    okClicked() {
      // if (this.localStorageKey4DontShowAgain) {
      //   if (this.checkboxDontShowAgain) {
      //     localStorageHelper.setItem(this.localStorageKey4DontShowAgain, true);
      //   }

      //   this.updateLocalStorageKey4DontShowAgain(null);
      // }

      this.showDialog = false;
      this.updateSystemDialog(null);
    },
    yesClicked() {
      if (this.systemDialog.actions.yes.callback) {
        this.systemDialog.actions.yes.callback();
      }

      this.okClicked();
    },
    noClicked() {
      if (
        this.systemDialog.actions.no &&
        this.systemDialog.actions.no.callback
      ) {
        this.systemDialog.actions.no.callback();
      } else {
        this.okClicked();
      }
    },
  },
};
</script>